import { Reveal } from "./Reveal";
import { STATS } from "../data/content";

export default function Stats() {
  return (
    <section className="bg-[#161617] text-white py-20 sm:py-28" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1} className="border-t border-[#d4af37]/40 pt-6">
              <p className="text-4xl sm:text-5xl font-semibold tracking-tight" data-testid={`stat-value-${i}`}>
                {s.value}
              </p>
              <p className="mt-3 text-sm text-[#a1a1a6] leading-relaxed max-w-[220px]">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
